var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article"},[(_vm.show)?_c('div',[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.article.content)}})]):_vm._e(),_vm._v(" "),_c('Laod',{ref:"laoding"}),_vm._v(" "),_c('Floating'),_vm._v(" "),_c('wxShare')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-534f8262","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/details.vue
// module id = null
// module chunks = 